import { useEffect, useState } from 'react';
import { Button, Checkbox, Col, Divider, Form, Input, message, Row, Tabs } from 'antd';

import {
  checkEmailService,
  checkPhoneService,
  codeCheckService,
  codeLoginService,
  loginPhoneService,
  registerService,
  sendCodeToRegisterLoginService,
} from '../services';
import { getNodeId, isEmail, onCloseLoginModal, phonePattern, setCookieTokens } from '../utils';
import { useCountDownCustom } from './hooks';

import './index.less';

let tokenChange: any = null; // token 定时器

const Login = (props: any) => {
  const { onLoginSuccess, activeKeyTab, setActiveKeyTab } = props;

  let client_id = getNodeId(); // 终端 id，前端后端约定
  const [isDisabledSubmit, setIsDisabledSubmit] = useState(true); // 短信
  const [isUserDisabledSubmit, setIsUserDisabledSubmit] = useState(true); // 账号

  const [loadingBtn, setLoadingBtn] = useState(false);

  // const [activeKeyTab, setActiveKeyTab] = useState('1');

  // 全局状态
  const [form] = Form.useForm();

  const { codeBtnDisabled, btnContent, enable, setEnable, startCountDown } = useCountDownCustom();

  useEffect(() => {
    setEnable(false);
    clearInterval(tokenChange); // 清空定时器
  }, []);

  // 错误提示
  const showMessageError = (content?: string) => {
    const text = content || '登录失败,账号或密码错误';
    message.error({
      content: text,
      key: 'loginError',
    });
  };

  // 发送短信验证
  const onSendCode = async () => {
    const { phone: pValue } = form.getFieldsValue();
    const phone = `+86${pValue}`;
    // 手机号校验成功
    // const res = await sendCodeService({ phone });
    const res = await sendCodeToRegisterLoginService({ phone });

    if (!res.error) {
      startCountDown();
      message.success('短信发送成功');
      setEnable(false);
    } else {
      message.error(`短信发送失败${res.error}`);
    }
  };

  // 登录成功获取用户信息
  const getUserInfo = async (token: string, refresh_token: string) => {
    await onLoginSuccess(token, refresh_token);
  };

  // 用户短信登录
  const messageLogin = async (values: any) => {
    const { phone, login_code } = values;
    const formatPhone = `+86${phone}`;
    let tempObj = {
      grant_type: 'password',
      login_type: 'register',
      kind: 3,
      username: formatPhone,
      login_code: login_code,
      // client_id,
    };

    // 校验是否注册过 API
    const checkReg = await codeCheckService({ phone: formatPhone, client_id });
    // 手机号不存在，自动注册 API
    if (checkReg?.data?.isExist == false) {
      const { code, msg } = await registerService({
        // 游客
        name: `学者${phone?.slice?.(-4) || ''}`,
        phone: phone,
        orgType: 0,
        orgName: '',
        src: 1,
      });
      if (code !== 200) {
        message.error({
          content: msg,
          key: 'registerError',
        });
      }
    }

    // const res = await loginPhoneService(tempObj);
    const res = await codeLoginService(tempObj).catch((err) => err?.response?.data);
    if (res?.access_token) {
      await getUserInfo(res.access_token, res.refresh_token); // 登录成功
    } else {
      let errText = '登录失败,账号或者验证码错误';
      if (res?.error === 'invalid grant: 1分钟内尝试超过5次，请稍后再试') {
        errText = '用户已被锁定，请1分钟后再次发送验证码';
      }
      // 登录失败
      showMessageError(errText);
    }
  };

  // 用户账号登录
  const accountLogin = async (values: any) => {
    const { username, password } = values;
    const accountType = isEmail(username) ? 'email' : 'phone';

    // 手机登录
    if (accountType == 'phone') {
      let tempObj = {
        grant_type: 'password',
        login_type: 'login',
        kind: 3,
        username: `+86${username}`, // todo 考虑其他国家
        password,
        // client_id: getNodeId("prod"),
        client_id,
      };

      // 校验手机号
      const res = await checkPhoneBySubmit({
        phone: tempObj.username,
        // client_id: getNodeId("prod"),
        client_id,
      });
      if (res) {
        // api 报错就提示 登录失败
        const { access_token, refresh_token } = await loginPhoneService(tempObj);
        if (access_token) {
          // 设置token
          await getUserInfo(access_token, refresh_token); // 登录成功
        } else {
          showMessageError();
        }
      }
    }

    // 邮箱登录
    if (accountType == 'email') {
      const res = await checkEmailBySubmit(username);
      if (!res) {
        // 邮箱不存在提示
        form.setFields([
          {
            name: 'username',
            errors: ['登录的账户需要先注册'],
          },
        ]);
        return;
      }

      //  邮箱登录
      let tempObj = {
        grant_type: 'password',
        login_type: 'login',
        kind: 2,
        username: `${username}`,
        password,
        client_id,
      };

      const result = await loginPhoneService(tempObj);
      const { access_token, refresh_token } = result;
      if (access_token) {
        await getUserInfo(access_token, refresh_token); // 登录成功
      } else {
        showMessageError();
      }
    }
  };

  // 校验手机号
  async function checkPhoneBySubmit(
    tempObj: any,
    type: string = 'username',
    error: string = '登录的手机需要先注册',
  ) {
    try {
      const result = await checkPhoneService(tempObj);
      if (result && result.data) {
        if (!result?.data?.isExist) {
          form.setFields([
            {
              name: type,
              errors: [error],
            },
          ]);
        }
        return result.data.isExist;
      }
      return false;
    } catch (e) {
      console.log('手机号校验异常', e);
    }
  }

  // 校验邮箱
  async function checkEmailBySubmit(value: any) {
    try {
      const payload = { email: value };
      const data = await checkEmailService(payload);
      if (data?.isExist) {
        // setIsExist(true);
        return true;
      } else {
        // setIsExist(false);
        return false;
      }
    } catch (e) {}
  }

  // 登录按钮
  const onFinish = async (values: any) => {
    try {
      setLoadingBtn(true);
      // 用户短信登录
      if (activeKeyTab == '1') {
        await messageLogin(values);
      }

      // 用户账号登录
      if (activeKeyTab == '2') {
        await accountLogin(values);
      }
    } catch (error) {
    } finally {
      setLoadingBtn(false);
    }
  };

  const handleFieldsChange = (fields: any, allFields: any) => {
    let isDisabledCheck = false;

    for (let fieldItem of allFields) {
      if (fieldItem.name[0] === 'phone') {
        if (fieldItem.errors?.length) {
          setEnable(false);
        } else {
          setEnable(true);
        }
      }
      if (fieldItem?.name[0] !== 'agreement') {
        // 不考虑协议
        if (fieldItem?.errors?.length > 0 || !fieldItem?.value) {
          //校验失败或者值为空
          isDisabledCheck = true;
          break;
        }
      }
    }

    if (activeKeyTab == '1') {
      setIsDisabledSubmit(isDisabledCheck);
    } else {
      setIsUserDisabledSubmit(isDisabledCheck);
    }
  };

  return (
    <>
      <Tabs
        tabBarGutter={0}
        defaultActiveKey="1"
        activeKey={activeKeyTab}
        size={'large'}
        onChange={(value: any) => {
          if (value != 3) {
            setActiveKeyTab(value);
          }
        }}
        // animated={false}
        tabPosition="top"
        items={[
          { key: '1', label: <div className={'loginTab'}>短信登录</div> },
          { key: '3', label: <Divider className={'loginDivider'} type="vertical" /> },
          { key: '2', label: <div className={'loginTab'}>账号登录</div> },
        ]}
      />
      <div className={'loginForm'}>
        <Form
          form={form}
          size={'large'}
          name="register"
          onFinish={onFinish}
          onFieldsChange={handleFieldsChange}
          scrollToFirstError
        >
          {activeKeyTab == '1' && (
            <div className={'tabPanelGroup'}>
              {/*短信登录*/}
              <Form.Item
                name="phone"
                label=""
                rules={[
                  {
                    required: true,
                    message: '请输入手机号',
                  },
                  {
                    pattern: phonePattern,
                    message: '请输入正确的手机号',
                  },
                ]}
              >
                <Input placeholder={'请输入手机号'} />
              </Form.Item>
              <Form.Item label="">
                <Row gutter={8}>
                  <Col span={12}>
                    <Form.Item
                      name="login_code"
                      noStyle
                      rules={[
                        { required: true, message: '请输入验证码' },
                        { pattern: /^[0-9]{6}$/, message: '请输入正确的验证码' },
                      ]}
                    >
                      <Input placeholder={'请输入验证码'} />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Button
                      className="codeBtn"
                      block
                      disabled={codeBtnDisabled}
                      type={enable ? 'primary' : 'default'}
                      onClick={onSendCode}
                    >
                      {btnContent}
                    </Button>
                  </Col>
                </Row>
              </Form.Item>

              <Form.Item
                name="agreement"
                valuePropName="checked"
                rules={[
                  {
                    validator(_, value) {
                      if (value === true) return Promise.resolve(undefined);
                      return Promise.reject('未勾选用户协议和隐私条款');
                    },
                  },
                ]}
              >
                <Checkbox>
                  <span className="checkText">
                    未注册用户登录后自动注册，勾选代表您已阅读并同意
                    <br />
                    <a
                      rel="noreferrer"
                      className="loginHref"
                      href="https://www.aminer.cn/protocol"
                      target={'_blank'}
                    >
                      《用户协议》
                    </a>
                    和
                    <a
                      rel="noreferrer"
                      className="loginHref"
                      href="https://www.aminer.cn/policy"
                      target={'_blank'}
                    >
                      《隐私政策》
                    </a>
                  </span>
                </Checkbox>
              </Form.Item>

              <Form.Item>
                <Button
                  disabled={isDisabledSubmit}
                  type="primary"
                  htmlType="submit"
                  loading={loadingBtn}
                  block
                >
                  登录
                </Button>
              </Form.Item>
            </div>
          )}

          {/*账号登录*/}
          {activeKeyTab == '2' && (
            <div className={'tabPanelGroup'}>
              <Form.Item
                name="username"
                label=""
                rules={[
                  {
                    required: true,
                    message: '请输入正确的手机号或邮箱',
                  },
                  {
                    pattern: /^1[23456789]\d{9}$|\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
                    message: '请输入正确的邮箱或手机号',
                  },
                ]}
              >
                <Input placeholder={'请输入手机号/邮箱'} />
              </Form.Item>

              <Form.Item
                name="password"
                label=""
                rules={[
                  {
                    required: true,
                    message: '请输入密码',
                  },
                ]}
              >
                <Input.Password visibilityToggle={false} placeholder={'请输入密码'} />
              </Form.Item>
              <div className={'checkContainer'}>
                <Form.Item
                  className="agreement_form_item"
                  name="agreement"
                  valuePropName="checked"
                  rules={[
                    {
                      validator(_, value) {
                        if (value === true) return Promise.resolve(undefined);
                        return Promise.reject('未勾选用户协议和隐私条款');
                      },
                    },
                  ]}
                >
                  <Checkbox>
                    <span className="checkText">
                      已阅读并同意
                      <a
                        rel="noreferrer"
                        className="loginHref"
                        href="https://www.aminer.cn/protocol"
                        target={'_blank'}
                      >
                        《用户协议》
                      </a>
                      和
                      <a
                        rel="noreferrer"
                        className="loginHref"
                        href="https://www.aminer.cn/policy"
                        target={'_blank'}
                      >
                        《隐私政策》
                      </a>
                    </span>
                  </Checkbox>
                </Form.Item>
                <a className="checkText aHref" onClick={() => props.onClickPwd('setPwd')}>
                  找回密码
                </a>
              </div>

              <Form.Item>
                <Button
                  type="primary"
                  disabled={isUserDisabledSubmit}
                  loading={loadingBtn}
                  htmlType="submit"
                  block
                >
                  登录
                </Button>
              </Form.Item>
            </div>
          )}
        </Form>
      </div>
    </>
  );
};

export default Login;
